import { render, staticRenderFns } from "./sharecode.vue?vue&type=template&id=2341f7e4&"
import script from "./sharecode.vue?vue&type=script&lang=ts&"
export * from "./sharecode.vue?vue&type=script&lang=ts&"
import style0 from "./sharecode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports